import('./bootstrap');
import 'telia-front-react/styles/global.css';
